import React from 'react';
import { PropTypes } from 'prop-types';
import Lang from '../language/services/Lang'
import InputFieldBaseHOC from './InputFieldBase';
import './TextFormInputField.scss'

const TextFormInputField = (props) => {
    let { propertyName, value, autoComplete, onBlur, onChange, isDisabled, placeholderKey, lang } = props;
    return (
        <input name={propertyName}
            type="text"
            value={value}
            placeholder={placeholderKey ? Lang.getValue(placeholderKey, lang) : ''}
            disabled={isDisabled === true}
            autoComplete={autoComplete || "off"}
            onChange={(ev) => { onChange(propertyName, ev.target.value) }}
            onBlur={() => { onBlur(propertyName) }}
        />
    );
}

TextFormInputField.propTypes = {
    propertyName: PropTypes.string.isRequired,
    labelKey: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
    autoComplete: PropTypes.string,
    onBlur: PropTypes.func.isRequired,
    onChange: PropTypes.func.isRequired,
    subtextKey: PropTypes.string,
    errorKey: PropTypes.string,
    isDisabled: PropTypes.bool,
    placeholderKey: PropTypes.string,
    lang: PropTypes.string.isRequired,
    hideIndicator: PropTypes.string
};


export default InputFieldBaseHOC(TextFormInputField);
